import client from "./Client";

const addSchool = (payload) =>
  client.post("/school/register", {
    ...payload,
  });

const getSchools = (page, rows, search) => {
  const params = {};
  if (page) {
    params.page = page;
  }
  if (rows) {
    params.rows = rows;
  }
  if (search) {
    params.search = search;
  }
  return client.get(`/schools`, {
    params,
  });
};

const getAllSchools = () => {
  return client.get(`/schools/list`);
};

const updateSchool = (school_id, payload) =>
  client.post("/school/update", {
    school_id,
    ...payload,
  });

const toggleSchool = (school_id, admin_id, active) =>
  client.post("/school/toggle", {
    school_id,
    admin_id,
    active,
  });

const getSingleSchool = (schoolId) => {
  return client.get(`/school/${schoolId}`);
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  addSchool,
  getSchools,
  updateSchool,
  getSingleSchool,
  toggleSchool,
  getAllSchools,
};
